































































































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { OrdersResp_Order, PrInternalStatus, Timestamp, File, DeleteFileReq_FileType, OrderAcceptPriceReq, OrdersResp_SettedPrice } from '@/apiv3/index'
import helpers from '@/helpers'
import Checklist from '../Checklist.vue'
import auth from '@/auth'
import { OrderService, SetStatusData, OrderStatus, Checks } from '@/api'

@Component({ components: { Checklist } })
export default class OrdersList extends Vue {
  @Prop() orders!: OrdersResp_Order[]
  @Prop() title!: string

  public PrInternalStatus = PrInternalStatus
  public blocked = false

  formatDateTs (value: Timestamp | undefined): string {
    return helpers.formatDateTs(value)
  }

  public getFileURL (file: File, ord: OrdersResp_Order | null): string {
    return helpers.getFileURL(file, ord)
  }

  toRework (order: OrdersResp_Order) {
    this.blocked = true

    const checks: Checks = []

    for (let i = 0; i < 35; i++) {
      if (order.checks[i]) {
        checks[i] = true
      } else {
        checks[i] = false
      }
    }

    const req: SetStatusData = {
      status: OrderStatus.CHECK_FAIL,
      checks: checks
    }

    OrderService.setStatus({ id: Number(order.id), requestBody: req }).then(() => {
      order.internalStatus = PrInternalStatus.IN_WORK
    }).finally(() => {
      this.blocked = false
    })
  }

  removeFile (order: OrdersResp_Order, fileId: bigint, fileIdx: number) {
    auth.adminClient().DeleteFile({ id: fileId, orderId: order.id, type: DeleteFileReq_FileType.WORK }).then(() => {
      order.workFiles.splice(fileIdx, 1)
    })
  }

  done (order: OrdersResp_Order) {
    this.blocked = true

    const req: SetStatusData = {
      status: OrderStatus.DONE
    }

    OrderService.setStatus({ id: Number(order.id), requestBody: req }).then(() => {
      order.internalStatus = PrInternalStatus.TO_PAY
    }).finally(() => {
      this.blocked = false
    })
  }

  acceptPrice (order: OrdersResp_Order, price: OrdersResp_SettedPrice) {
    if (price.user === undefined) {
      return
    }

    this.blocked = true

    const req: OrderAcceptPriceReq = {
      id: order.id,
      userId: price.user.id,
      price: price.price
    }

    auth.adminClient().OrderAcceptPrice(req).then(() => {
      order.internalStatus = PrInternalStatus.IN_WORK
      order.user = price.user
    }).finally(() => {
      this.blocked = false
    })
  }
}
